export interface DownloadFileParams {
  blob: Blob;
  fileName: string;
}

export const downloadFile = ({ blob, fileName }: DownloadFileParams): void => {
  const url = URL.createObjectURL(blob);

  const downloadAnchor = document.createElement("a");
  downloadAnchor.href = url;
  downloadAnchor.download = fileName;
  downloadAnchor.click();

  URL.revokeObjectURL(url);
};

export const loadExternalScript = (url: string): Promise<void> => {
  return new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = url; // 동적으로 외부 URL에서 모듈을 가져옴

    script.onload = () => {
      resolve();
    };
    script.onerror = error => {
      console.error("Error loading script:", error);
      reject(error);
    };
    document.body.appendChild(script);
  });
};
